import React from 'react'
import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

const drawAnimation = keyframes({
  from: {
    strokeDasharray: '0 100',
  },
  to: {
    strokeDasharray: '100 0',
  },
})

const ProgressBarIcon = ({ tabTimeOutInSecond }: { tabTimeOutInSecond: number }) => {
  const { classes } = useStyles()
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="12" stroke="#EFF2F9" strokeWidth="3" />
      <circle
        className={classes.animateDrawAnimation}
        style={{
          strokeDasharray: '0 100',
          stroke: '#60A5FA',
          animationDuration: `${tabTimeOutInSecond}s`,
        }}
        cx="16"
        cy="16"
        r="12"
        stroke="#BEC4D5"
        strokeWidth="3"
        pathLength="100"
        transform="rotate(-90 16 16)"
      />
    </svg>
  )
}

export default ProgressBarIcon

const useStyles = makeStyles()({
  animateDrawAnimation: {
    animation: `${drawAnimation} linear forwards`,
  },
})
